<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-0A1129">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%;">
                            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                                <h2 class="mb-3 custom-54px-600 text-right text-white">Portal Pembelajaran yang Penuh <br /> dengan <strong style="color:#4d9ae0">Perkembangan</strong></h2>
                                <CRow class="mt-5">
                                    <CCol sm="8">
                                        <div style="max-width:400px">
                                            <h3 class="custom-20px-400">Dengan gabungan kreativiti, inovasi, dan ketelitian dalam pertukangan, kami menghidupkan visi anda dengan menghasilkan rekaan yang memukau. </h3>
                                        </div>
    
                                    </CCol>
                                    <CCol sm="4">
                                        <div class="text-right">
                                            <CButton type="button" class="border-white-half custom-16px-600 text-white mt-5">Jom Bertanya dengan Kami <img src="../assets/img/flyhigh/ArrowRight.png" width="20px" /></CButton>
                                        </div>
    
                                    </CCol>
                                </CRow>
    
                            </CCol>
                        </div>
                        <CCol sm="12" style="width:90%;margin: 0 auto;background-size: cover;">
                            <section class="why-section py-5 text-center text-light">
    
                                <div class="spotlight-container">
                                    <div class="spotlight"></div>
                                    <h2 class="section-title">Tentang Kami</h2>
                                </div>
                            </section>
                            <CRow class="mt-4">
                                <CCol sm="2">
                                    <h3 class="custom-20px-600 text-white">Our Team <img src="../assets/img/flyhigh/Arrow.png" width="30px" class="text-right ml-1" /></h3>
                                    <h4 class="bottom-fixed" style="position:absolute;bottom:10px">
                                        Erick <br /> Josh
                                        <br /> Mike
                                        <br /> Emily
                                        <br /> Sarah
                                        <br /> Bella
                                    </h4>
                                </CCol>
                                <CCol sm="10">
                                    <img src="@/assets/img/flyhigh/flyhigh-ambassador.png" alt="FlyHigh Ambassador Banner" class="img-fluid rounded" />
                                </CCol>
                                <CCol sm="12">
                                    <h3 class="custom-24px-400 font-color-888 text-left mt-5">
                                        FlyHigh merupakan sebuah pusat tuisyen yang diasaskan pada tahun 2019. Namun demikian, apabila pandemik Covid-19 melanda pada tahun 2020, Fly High telah menukar strategi perniagaannya kepada sistem pembelajaran dalam talian. Strategi sistem pembelajaran
                                        dalam talian ini sangat memberangsangkan dan mendapat sambutan yang amat menggalakan daripada ibu bapa yang inginkan satu sistem pembelajaran alternatif yang lebih selamat setelah Covid-19 menghalang kepada sistem pembelajaran
                                        bersemuka.
                                        <br /><br /> Melihat kepada sambutan ibu bapa yang amat menggalakan ini, ianya telah mendorong pihak syarikat untuk memperbaiki sistem pembelajaran yang sedia ada dengan membangunkan satu platform dan aplikasi pembelajaran
                                        dalam talian yang lebih sempurna.
                                        <br /><br /> Apa yang nyatanya, platform ini sangat bermanfaat untuk semua pihak khususnya ibu bapa yang mempunyai anak-anak yang sedang belajar. Dengan dua saluran utama yang akan berfungsi untuk menyediakan perkhidmatan
                                        pembelajaran dalam talian ini, iaitu Laman Web dan Telefon Pintar, ianya akan memberikan pilihan kepada pengguna yang Rigid dan pengguna yang Mobile.
                                    </h3>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="12" style="width:90%; margin: 0 auto; background-size: cover;">
                            <!-- Row 1: Visi di sebelah kiri -->
                            <CRow>
                                <CCol sm="8" class="mt-5 text-left">
                                    <CCard class="custom-border-blue-glow p-3">
                                        <p class="custom-18px-500 text-white">VISI</p>
                                        <p class="custom-20px-500 text-left text-white">
                                            Visi Fly High adalah memberi Pendidikan yang terbaik kepada semua orang tidak kira peringkat umur.
                                        </p>
                                    </CCard>
                                </CCol>
                            </CRow>
    
                            <!-- Row 2: Misi di sebelah kanan -->
                            <CRow class="justify-content-end">
                                <CCol sm="8" class="text-right">
                                    <CCard class="custom-border-blue-glow p-3">
                                        <p class="custom-18px-500 text-white text-left">MISI</p>
                                        <p class="custom-20px-500 text-left text-white">
                                            Misi Fly High ingin memberi panduan yang sewajarnya supaya semua dapat meningkatkan nilai dalam setiap aspek kehidupan.
                                        </p>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CCol>
    
                </CRow>
                </CCol>
            </CCol>
    
    
            <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../components/Footer.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            Names: ""

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("About");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("About");
                console.error("Error fetching user info:", error);
            }
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>